import type SubscriptionsV1 from 'bundles/naptimejs/resources/subscriptions.v1';
import { isStripePaymentProcessor } from 'bundles/subscriptions-common/utils/isStripePaymentProcessor';

export const isStripeSubscription = (subscription?: SubscriptionsV1) =>
  isStripePaymentProcessor(subscription?.paymentProcessorId);
